import * as FluxUtils from 'flux/utils';

import { DispatcherBaseAction, AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { developmentMode } from '../submodules/utils/ReactScriptHelper';

export interface DebugState {
    enabled: boolean;
    id: string;
    network_requests: string;
    actions: string;
    app_msg: string;
    console_log: string;
    log_errors: string;
    log_to_console: string;
}

class DebugStoreClass extends FluxUtils.ReduceStore<DebugState, unknown> {
    public getInitialState(): DebugState {
        return {
            enabled: developmentMode,
            id: '',
            network_requests: 'false',
            actions:  'false',
            app_msg:  'false',
            console_log:  'false',
            log_errors: 'false',
            log_to_console: 'false',
        };
    }

    public reduce(state: DebugState, action: DispatcherBaseAction): DebugState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            // FixMe
            case ActionConstants.UPDATE_DEBUG_SETTINGS:
                return jQuery.extend({}, state, action.value);
            case ActionConstants.ENABLE_DEBUG_TAB:
                return jQuery.extend({}, state, {enabled: true});
            default:
                break;
        }
        return state;
    }
}

export let DebugStore: DebugStoreClass = new DebugStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/DebugStore.ts